module.exports = __webpack_public_path__ + "static/media/subImg2.2acaf338.png";